import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  CircularProgress,
  TableRow,
  TablePagination,
  TableHead,
  TableContainer,
} from "@mui/material";
import { axiosInstance } from "../../axiosInstance";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const columns = [
  { id: "name", label: "NAME", minWidth: 100, align: "center" },
  { id: "phone_number", label: "PHONE NUMBER", minWidth: 100, align: "center" },
  { id: "comment", label: "COMMENT", minWidth: 170, align: "center" },
  { id: "created_at", label: "CREATED AT", minWidth: 170, align: "center" },
];

function createData(name, phone_number, comment, created_at) {
  return { name, phone_number, comment, created_at };
}

const formatValue = (columnId, value) => {
  if (columnId === "created_at") {
    return value && dayjs(value).isValid()
      ? dayjs(value).format("DD/MM/YYYY")
      : "--";
  }
  return value === null || value === undefined || value === "" ? "--" : value;
};

export function ContactUsData() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [contactUsList, setContactUsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const fetchContactUs = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get("/admin/contact-us/");
      console.log("✅ Contact Us list response:", res.data);
      if (res.data.status === "success") {
        setContactUsList(res.data.data || []);
      } else {
        setError("Failed to fetch Contact Us data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Contact Us data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContactUs();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <div>
      <div className="admin-top-container">
        <div className="admin-listText">Contact Us Data</div>
      </div>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="table-header"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : contactUsList.length > 0 ? (
                contactUsList
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow
                      className="table-row"
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                      sx={{
                        backgroundColor: index % 2 === 1 ? "#E7F0F9" : "white",
                      }}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            className={`${column.id}-column tableCelldata`}
                            sx={{
                              color:
                                column.id === "status"
                                  ? value === "Active"
                                    ? "green"
                                    : "red"
                                  : "inherit",
                            }}
                          >
                            {formatValue(column.id, row[column.id])}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={columns.length}
                    align="center"
                    style={{ padding: "40px 0" }}
                  >
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
          component="div"
          count={contactUsList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
